import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.land-documents-index-page', () => {
  import('./internal/land-documents-index-page').then(({ default: Component }) => Component());
});
